import { getCookie } from "../cookie-utils";

/** Matches ThemeContext initial state (cookie → system preference). */
export function getInitialDarkMode() {
  const storedTheme = getCookie("theme");
  if (storedTheme) {
    return storedTheme === "dark";
  }

  return (
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)")?.matches === true
  );
}
